import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { NotificationsService } from 'angular2-notifications';
import { IMyDpOptions } from 'mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { ConsultaMovimentacoesPixService } from './consulta-movimentacoes-pix.service';

@Component({
  selector: 'ngx-consulta-movimentacoes-pix',
  templateUrl: './consulta-movimentacoes-pix.component.html',
  styleUrls: ['./consulta-movimentacoes-pix.component.scss']
})
export class ConsultaMovimentacoesPixComponent implements OnInit {

  @ViewChild('myTable', null)
  private myTable: DatatableComponent;

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  public listStatus = null;
  public listStatusArbi = null;
  public cnpjCpf = null;
  public formConsultaMovimentacoesPix = null;
  public rowData = null;
  public tableLimit = 20;
  public columnsTabe = null;


  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
  };

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: ConsultaMovimentacoesPixService,
    private dateUtilService: DateUtilService,
    private exportCsvService: ExportCsvService,
    private router: Router,
    private notificationService: NotificationsService,
    private datatableService: DatatableService,
    private spinnerService: NgxSpinnerService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.formConsultaMovimentacoesPix = this.formBuilder.group({
      identificador: [null],
      dataInicio: [null],
      dataFim: [null],
      status: [null],
      statusArbi: [null]
    });

    this.listStatus = ["CONCLUIDO", "FALHA", "PENDENTE", "TRANSACAO_NEGADA"];
  }

  buscarLista(data?: any, page?: string) {
    this.spinnerService.show();
    let params = new HttpParams();

    if (data.identificador != null && data.identificador.length > 0) {
      params = params.append('cpfCnpj', data.identificador);
    }
    if (data.dataInicio != null) {
      let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio', dataInicio);
    }
    if (data.dataFim != null) {
      let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim);
    }
    if (data.status != null && data.status.length > 0) {
      params = params.append('status', data.status);
    }
    if (data.statusArbi != null && data.statusArbi.length > 0) {
      params = params.append('statusArbi', data.statusArbi);
    }
    params = params.append('size', String(this.tableLimit));
    if (page) {
      params = params.append('page', page);
    }

    this.service.getPixList(params, (response => {
      this.rowData = response.content;
      this.rowData = this.rowData.map(data => {
        return {
          nomeBeneficiario: data.nomeBeneficiario,
          cpfCnpjBeneficiario: data.cpfCnpjBeneficiario,
          dataEnvio: this.dateUtilService.formatDate(data.dataEnvio, "DD-MM-YYYY"),
          valorOperacao: data.valorOperacao,
          status: data.status,
          statusArbi: data.statusArbi
        }
      });
      this.paginationService.setInfo(response);
      this.spinnerService.hide();
      if (response.content.length == 0) {
        this.notificationService.warn('Não encontrada operação Pix com os filtros informados.');
      }

    }), error => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
  }

  exportar(data?: any) {
    let params = new HttpParams();
    params = params.append('allElements', 'true');

    if (data.identificador != null && data.identificador.length > 0) {
      params = params.append('cpfCnpj', data.identificador);
    }
    if (data.dataInicio != null) {
      let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio', dataInicio);
    }
    if (data.dataFim != null) {
      let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim);
    }
    if (data.status != null && data.status.length > 0) {
      params = params.append('status', data.status);
    }
    if (data.statusArbi != null && data.statusArbi.length > 0) {
      params = params.append('statusArbi', data.statusArbi);
    }

    this.service.getPixList(params, (response => {
      if (response.content.length == 0) {
        this.notificationService.warn('Não há dados para exportar!');
      }

      this.rowData = response.content;
      this.rowData = this.rowData.map(data => {
        return {
          nomeBeneficiario: data.nomeBeneficiario,
          cpfCnpjBeneficiario: data.cpfCnpjBeneficiario,
          dataEnvio: this.dateUtilService.formatDate(data.dataEnvio, "DD-MM-YYYY"),
          valorOperacao: data.valorOperacao,
          status: data.status,
          statusArbi: data.statusArbi
        }
      });
      let columnsTabe = [
        { columnName: "nomeBeneficiario", newColumnName: "Nome Beneficiario" },
        { columnName: "cpfCnpjBeneficiario", newColumnName: "CpfCnpj Beneficiario" },
        { columnName: "dataEnvio", newColumnName: "Data Envio" },
        { columnName: "valorOperacao", newColumnName: "Valor" },
        { columnName: "status", newColumnName: "Status" },
        { columnName: "statusArbi", newColumnName: "Status Arbi" },
      ];

      this.exportCsvService.exportCsv(this.rowData, columnsTabe, ',', 'PixComFalha');

    }), null);
  }

  executarJob() {
    this.spinnerService.show();

    let param = {
      job: 'PROCESS_SCHEDULER_PIX_VERIFICATION'
    };

    this.service.executeJob(param, (response => {
      this.spinnerService.hide();
      if (response.success) {
        this.buscarLista(this.formConsultaMovimentacoesPix.value);
        this.notificationService.success(response.message);
      } else {
        this.notificationService.error(response.message);
      }
    }), (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
  }

  isCPF(): boolean {
    return this.cnpjCpf == null ? true : this.cnpjCpf.length < 12 ? true : false;
  }

  getCpfCnpjMask(): string {
    return this.isCPF() ? '000.000.000-009' : '00.000.000/0000-00';
  }

  ngOnInit() {
    this.datatableService.subscribeTable(this.myTable);

    this.service.getStatusArbiList((response => {
      if (response != null) {
        this.listStatusArbi = response;
      }
    }), null);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

}
